import useAxios from 'axios-hooks';
import React from 'react';
import FluentSelect from '../../../../Forms/FluentSelect';

const DashboardTasksDropDown = ({ ...rest }) => {
    const [{ data, loading }] = useAxios({ url: '/dashboardTasks/all-tasks' });

    const options = data?.map((dashboardTaskSlug) => ({
        value: dashboardTaskSlug,
        label: dashboardTaskSlug,
    }));

    return <FluentSelect options={options} disabled={loading} {...rest} />;
};
export default DashboardTasksDropDown;
